export default __webpack_public_path__ + "static/media/bandera-portugues-tower.83474938.svg";